import React from 'react';
import { Box, Icon } from '@quintoandar-tokko/jopijs';
import styles from './profilePicture.module.scss';
import ImageNext from '@/components/shared/ImageNext';

function ProfilePicture({ src, width = 48, alt, type = 'contact' }) {
  const iconType = {
    contact: 'icon-contactos',
    branch: 'icon-empresa',
    agent: 'icon-agente',
  };
  return (
    <Box
      __css={{ width, height: width, minWidth: width }}
      className={styles.profilePictureContainer}
    >
      {src ? (
        <ImageNext
          className={styles.avatarImage}
          width={width}
          height={width}
          alt={alt}
          src={src}
        />
      ) : (
        <Box className={styles.avatarPlaceholder}>
          <Icon icon={iconType[type]} />
        </Box>
      )}
    </Box>
  );
}

export default ProfilePicture;
